/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React, { useEffect, useState } from "react";
import { Container, Segment, Grid, Modal, Button } from "semantic-ui-react";
import styles from "./Footer.module.css";
import TermsAndConditions from "../Authenticator/LandingPage/TermsAndConditions";
import { resetUrlPath } from "../Authenticator/utils";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const [showTos, setShowTos] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    if (window.location.pathname === "/terms" && !showTos) {
      setShowTos(true);
    }
  }, [showTos]);

  return (
    <Segment vertical className={styles.footer}>
      <Container>
        <Grid divided inverted stackable>
          <Grid.Row>
            <Grid.Column width={3}>
              <a
                className={styles.footerLink}
                href="https://www.verimatrix.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Verimatrix
              </a>
            </Grid.Column>

            <Grid.Column width={4}>
              <span
                className={styles.footerLink}
                onClick={() => setShowTos(true)}
              >
                {t("terms_and_conditions")}
              </span>
            </Grid.Column>

            <Grid.Column width={4}>
              <a
                className={styles.footerLink}
                href="https://www.verimatrix.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("privacy_notice")}
              </a>
            </Grid.Column>
            <Grid.Column width={4} floated="right">
              Version {process.env.REACT_APP_GIT_SHA || "1.0"}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>

      <Modal open={showTos} size="large">
        <Modal.Content image scrolling style={{ backgroundColor: "#f8f6fa" }}>
          <div style={{ maxWidth: "1000px" }}>
            <TermsAndConditions />
          </div>
        </Modal.Content>
        <Modal.Actions style={{ margin: 0 }}>
          <Button
            color="green"
            onClick={() => {
              setShowTos(false);
              resetUrlPath();
            }}
          >
            {t("ok")}
          </Button>
        </Modal.Actions>
      </Modal>
    </Segment>
  );
};

export default Footer;
